export default ({ store, next }) => {
    store.state.auth.user.roles.find((role) => {
        if (role.name == 'manager_chart') {
            next({ name: 'Dashboard' });

            return false;
        }

        next();
    });
}